/*
 * File: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice\src\Content\Offers\OfferCollapsContent\OfferCollapsContent.tsx
 * Project: c:\Users\j.mazat\Desktop\Moby\MobyFleet\mobyfleet_backoffice
 * Created Date: Friday October 18th 2024
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday October 18th 2024 3:48:21 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2024 Autobuy SAS
 * -----
 */

import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import { CustomTabPanel } from "Content/Stats/Stats";
import AttribuedCarTab from "../AttribuedCar/AttribuedCarTab/AttribuedCarTab";
import OfferFiles from "../OfferFiles/OfferFiles";
import OfferFileService from "Services/Offer/OfferFileService";
import translator from "MultiLanguage/TranslationWrapper";

type OfferCollapsContentProps = {
    offerID: string,
    setterCarCount: (nbCar: number, isDelete?: boolean) => void
    setterFileCount: (nbFile: number, isDelete?: boolean) => void,
};

export function OfferCollapsContent(props: OfferCollapsContentProps) {
    const [value, setValue] = useState(0);

    const handleSave = (upload: FileList) => {
        return OfferFileService.addFile(props.offerID, upload);
    };

    const handleGetFile = () => {
        return OfferFileService.getFile(props.offerID);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={value} onChange={(e, val) => setValue(val)} aria-label="User-tabs-selector">
                    <Tab label={translator.decode("table.headers.Car")} />
                    <Tab label={translator.decode("table.headers.File")} />
                </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0} idlabel={"user-tab"} aria={"user-tab"}>
                <AttribuedCarTab offerID={props.offerID} setterCarcount={props.setterCarCount} setterFileCount={props.setterFileCount} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1} idlabel={"user-tab"} aria={"user-tab"}>
                <OfferFiles offerID={props.offerID} changeFileCount={props.setterFileCount} getter={handleGetFile} saving={handleSave} />
            </CustomTabPanel>
        </Box>
    );
};
